// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.
import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import Modal from 'react-bootstrap/Modal'
import { connect } from 'react-redux'
import { Circles } from 'react-loader-spinner'

function AutoRenewal(props) {
    const { setShow, show, handleSubmit, isLoading, formData, setActive, setPage } = props
    const handleClose = () => {
        setShow(false)
        if (formData?.proRateAPIData?.show_auto_consent == '1') {

            // window.location.reload(true)
            setActive('home')
            setPage('home')
        }
    }

    return (
        <Modal show={show} size='lg' onHide={handleClose} centered>

            <Modal.Header closeButton> <Modal.Title>Confirm Your Booking</Modal.Title> </Modal.Header>
            <Modal.Body>

                <div className="px-4">
                    {/* <p className="mb-1">You have Selected the Auto Renewal Mode.</p> */}
                    {/* <p>When purchasing the permit, you opted for auto-renewal, which means your permit will automatically renew on the 1st of each month, with the renewal amount being charged to your saved payment method on that day. If you wish to change this setting, please uncheck the auto-renewal option on the previous screen before finalizing your purchase.</p> */}
                    {formData?.proRateAPIData?.show_auto_consent == '1' ?
                        <p>{formData?.proRateAPIData?.show_auto_consent_msg}</p> :
                        <p>When purchasing the permit, you opted for auto-renewal, which means your permit will automatically renew on the 1st of each cycle, with the renewal amount being charged to your saved payment method on that day. If you wish to change this setting, please uncheck the auto-renewal option on the previous screen before finalizing your purchase.</p>
                    }

                    {/* <p className="text-danger fw-bold">Please Un-check if you don&apos;t what to enable this feature</p> */}
                </div>
                <div className="modal-footer border-0 p-0 justify-content-center">
                    <button type="button" onClick={handleClose} className="btn btn-secondary" >Cancel</button>
                    <button id="next-btn" type="button" className="btn btn-primary d-flex step-btn" onClick={() => handleSubmit(formData)} disabled={isLoading}>Continue {isLoading ? <span className=' ms-2'><Circles
                        height="20"
                        width="20"
                        color="#ffffff"
                        ariaLabel="circles-loading"
                        visible={true}
                    /></span> : null}</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

AutoRenewal.propTypes = {
    dispatch: PropTypes.func,
    setShow: PropTypes.func,
    show: PropTypes.bool,
    isLoading: PropTypes.bool,
    handleSubmit: PropTypes.func,
    formData: PropTypes.object,
    setPage: PropTypes.func,
    setActive: PropTypes.func,
}

AutoRenewal.defaulProps = {
    dispatch: noop,
    setShow: noop,
    show: false,
    isLoading: false,
    formData: {},
    handleSubmit: noop,
    setPage: noop,
    setActive: noop,
}

function mapStateToProps({ userDetailsReducer }) {
    return {
        loader: userDetailsReducer?.loader,
        loaderSms: userDetailsReducer?.loaderSms,
        loaderDownload: userDetailsReducer?.loaderDownload,
    }
}
export default connect(mapStateToProps)(AutoRenewal) 